import React from 'react';
import styled from 'styled-components';
import HintSmallWrapper from '../../shared/component/headless/button/HintSmallWrapper';
import { getHintMessage } from '../../shared/constants/hintMessages';
import { useAboutPage } from '../../shared/hooks/page/useAboutPage';

const AboutTopBarFixed: React.FC = () => {
  const {
    isEditMode,
    canShowMember: canShow,
    memberInfo,
    engVisible,
    handleEngVisible,
    isExtended,
    setIsExtended,
    isOwner,
  } = useAboutPage();

  return (
    <TopBar>
      <LanguageSelector>
        {isEditMode && canShow && memberInfo && (
          <HintSmallWrapper
            content={
              engVisible
                ? getHintMessage('ABOUT_ENG_VISIBILITY_HIDE')
                : getHintMessage('ABOUT_ENG_VISIBILITY_EXPAND')
            }
            toLeft={true}
          >
            <EngVisibilityButton
              type="button"
              $hidden={!engVisible}
              onClick={() => void handleEngVisible(!engVisible)}
            >
              ENG
            </EngVisibilityButton>
          </HintSmallWrapper>
        )}
      </LanguageSelector>
      {isOwner && <ToggleButton onClick={() => setIsExtended(!isExtended)}>
        {isExtended ? '<  >' : '<>'}
      </ToggleButton>}
    </TopBar>
  );
};

export default AboutTopBarFixed;

const TopBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  width: 100%;
  margin-top: 18px;
`;

const LanguageSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const EngVisibilityButton = styled.button<{ $hidden: boolean }>`
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme }) => theme.colors.color_Gray_04};
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  text-decoration: ${({ $hidden }) => ($hidden ? 'line-through' : 'none')};
`;

const ToggleButton = styled.div`
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme }) => theme.colors.color_Gray_05};
  cursor: pointer;
`;
